<template lang="html">
  <div class="content-item-message">
    <!-- 新增匿名代码 start -->
    <img class="avater" v-if="!is_actual" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E7%A5%9E%E7%A7%98%E5%A4%B4%E5%83%8F.png?x-oss-process=image/resize,m_fill,w_72,h_72">
    <!-- 新增匿名代码 end -->
    <!-- <img class="avater" v-else-if="avatar" v-lazy="`${avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`" /> -->
    <!-- <img
      class="avater"
      @click.stop="goDDconversation"
      v-else-if="avatar"
      v-lazy="`${real_avatar!=='null' && real_avatar!=='' ? real_avatar:avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`"/> -->
      <van-image
        v-else
        width='36px'
        height='36px'
        fit="cover"
        round
        class="avater"
        @click="goDDconversation"
        :src="`${real_avatar!=='null' && real_avatar!=='' ? real_avatar:avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`"
      >
        <template v-slot:error>{{ getErrorName }}</template>
      </van-image>
    <!-- <img class="avater" @click.stop="goDDconversation" v-else src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/default-profile.png?x-oss-process=image/resize,m_fill,w_72,h_72"/> -->
    <div class="content-item-body" @click="goCreate">
      <div class="content-item">
        <!-- 新增匿名代码 start -->
        <h2 v-if="!is_actual">匿名用户</h2>
        <!-- 新增匿名代码 end -->
        <h2 @click.stop="goDDconversation" v-else>{{fullname !== '' && fullname !=='null' ? fullname : nickName}}</h2>
          <ThumbUpItem @click="thumbsUp" v-bind="getThumbUp" />
      </div>
      <h5 class="time">
        <span>{{getShowTime(crateTime)}}
        </span>
        <span v-if="(users && users.id === user__id)" class="delete" @click.stop="deleteMessage">删除</span>
      </h5>
      <span v-if="parentCommentId" class="desc">回复<span class="parent">@{{parentNickName}}：</span><span v-html="content"></span></span>
      <span v-else class="desc" v-html="content"></span>
    </div>
  </div>
</template>
<script>
import { getBeforeTimeStr } from '../utils/date'
import { post, _delete } from '../utils/request'
import { openSingleChat } from '../utils/utils'
import { get } from '../utils/token'
import ThumbUpItem from './thunmbUpItem'
import { Toast } from 'vant'
import { messageInform } from '../api/api'
export default {
  components: {
    ThumbUpItem
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    parentCommentId: {
      type: Number,
      default: 0
    },
    parentNickName: {
      type: String,
      default: ''
    },
    nickName: {
      type: String,
      default: ''
    },
    user__id: {
      type: Number,
      default: 0
    },
    crateTime: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    circleId: {
      type: Number,
      default: 0
    },
    avatar: {
      type: String,
      default: ''
    },
    real_avatar: {
      type: String,
      default: ''
    },
    upCount: {
      type: Number,
      default: 0
    },
    isUp: {
      type: Boolean,
      default: false
    },
    is_actual: {
      default: false
    },
    fullname: {
      type: String
    },
    user_mobile: {
      type: String
    },
    visible_range: {
      type: String
    },
    user: {
      type: Object
    }
  },
  data () {
    return {
      users: get('user')
    }
  },
  mounted () {
    // const _this = this
    // dd.device.base.getPhoneInfo({
    //   onSuccess: function (data) {
    //     // alert('现在是手机移动端')
    //     _this.isPc = false
    //   },
    //   onFail: function (err) {
    //     alert(JSON.stringify(err))
    //   }
    // })
  },
  methods: {
    // 跳转钉钉聊天框逻辑
    goDDconversation () {
      // 先判断是否为移动钉钉端
      if (!this.is_actual) {
        return
      }
      openSingleChat({
        name: this.fullname ? this.fullname : this.nickName,
        userId: this.user.jobCode
      })
    },
    getShowTime (time) {
      return getBeforeTimeStr(time)
    },
    goCreate () {
      let nickName = '匿名用户'
      if (this.is_actual) {
        nickName = this.fullname
      }
      this.$router.push({
        path: '/exerland/create',
        query: {
          circleId: this.circleId,
          pid: this.id,
          parentNickName: nickName,
          mobile: this.user_mobile,
          isAnonymous: this.is_actual,
          visible_range: this.visible_range
        }
      })
    },
    deleteMessage () {
      const user = get('user')
      const promise = _delete({
        url: '/circle/comment',
        data: {
          userId: user.id,
          commentId: this.id
        }
      })
      promise.then(res => {
        const { data: { message } } = res
        this.$emit('deleteMessage', this.id)
        this.$bus.$emit('UPDynamicDetail', this.circleId)
        this.$bus.$emit('UPDynamicListDetail', this.circleId)
        Toast.success(message)
      })
    },
    thumbsUp (callback) {
      const _this = this
      const promsie = post({
        url: `/circle/isUpComment/${this.id}/${get('user').id}`,
        data: {
          isUp: !this.isUp
        }
      })
      promsie.then(res => {
        const user = get('user')
        const { status } = res
        if (Object.is(status, 200)) {
          if (!_this.isUp && _this.visible_range !== 'oversea') {
            messageInform({
              circle_id: _this.circleId,
              action_type: 3,
              mobile: _this.user_mobile,
              operator_mobile: user.username,
              is_anonymous: !_this.is_actual,
              comment_id: _this.id
            })
          }
          if (callback) {
            callback()
          }
          this.$emit('thumbsUp')
          this.$bus.$emit('UPDynamicDetail', this.circleId)
          this.$bus.$emit('UPDynamicListDetail', this.circleId)
        }
      })
    }
  },
  computed: {
    getErrorName () {
      const name = this.fullname ? this.fullname : this.nickName
      for (let i = 0; i < name.length; i++) {
        const charCode = name.charCodeAt(i)
        if (charCode >= 0x4e00 && charCode <= 0x9fff) {
          return name.charAt(i)
        }
      }
      return name[0]
    },
    getThumbUp () {
      return {
        isUp: this.isUp,
        // url: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-block.svg',
        // url1: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-grey.svg',
        upCount: this.upCount,
        label: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content-item-message {
  padding: 23px 3.73vw 8px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  .avater {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 16px;
  }
  .content-item-body {
    cursor: pointer;
    .content-item {
      display: flex;
      justify-content: space-between;
      h2 {
        font-size: 16px;
        font-family: SFProText-Semibold, SFProText;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        margin-bottom: 1px;
      }
      .content-item-right {
          display: flex;
          align-items: center;
          margin-right: 20px;
          img {
            width: 15px;
            height: 15px;
            margin-right: 8px;
          }
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
          }
          &:last-child {
            margin-right: 0;
          }
        }
    }
    .time {
      font-size: 13px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: rgba(60, 60, 67, 0.6);
      display: flex;
      align-items: center;
      .delete {
          display: inline-block;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(87,107,148,1);
          margin-left: 16px;
        }
    }
    .desc {
      white-space: pre-wrap;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;
      width: 79.2vw;
      // text-overflow: ellipsis;
      // overflow: hidden;
      display: -webkit-box;
      // -webkit-line-clamp: 3;
      // -webkit-box-orient: vertical;
      margin-bottom: 10px;
    }
    .parent {
      color: #888888;
    }
    .content-item-imgs {
      margin-bottom: 11px;
      img {
        width: 92px;
        height: 92px;
        margin-right: 4px;
      }
    }
    .content-bottom {
      display: flex;
      height: 44px;
      align-items: center;
    }
  }
}
</style>
